module.exports = __webpack_public_path__ + "img/ic_build_year.85ba2976.svg";